import { ApplicationRef, createComponent, EnvironmentInjector, Injectable } from '@angular/core';
import { getGender } from 'gender-detection-from-name';
import { BehaviorSubject } from 'rxjs';

const rand = max => Math.floor(Math.random() * max)

export interface BotaoChat {
  texto: string
  url: string
  tipo: 'resposta' | 'link' | 'bloqueado'
}

@Injectable({
    providedIn: 'root'
})
export class ChatService {

  private _chatLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public get chatLoaded$() {
    return this._chatLoaded.asObservable();
  }

  public set chatLoaded(value: boolean) {
    this._chatLoaded.next(value);
  }

    constructor(private injector: EnvironmentInjector,
      private applicationRef: ApplicationRef) { }
    public messages: any[] = [];

    public get menssagemPersistidas(){
      return localStorage.getItem("Qiowio27");
    };

    public set menssagemPersistidas(msg){
      localStorage.setItem("Qiowio27",msg);
    };

    public get expTime(){
      return localStorage.getItem("Qiowio25")
    }

    public set expTime(expTime){
      localStorage.setItem("Qiowio25",expTime)
    }

    private _chatApiUrl = "";

    public get chatApiUrl(){
      return this._chatApiUrl;
    }

    public set chatApiUrl(chatApiUrl){
      this._chatApiUrl = chatApiUrl;
    }

    public get appApiUrl(){
      if(this.chatApiUrl != ""){
        return this.chatApiUrl.replace('chat-app','app').replace("widget","");
      }
    }

    public logoUrl: string = "";

    public get logoPadrao(): string {
      if (this.logoUrl != null && this.logoUrl !== "") {
        return this.logoUrl;
      }
      return this.appApiUrl + `assets/images/logo/new-logo-white.png`;
    }

    public operator = {
        name: '',
        status: 'offline',
        avatar: '',
    }

    public sistema = {
      name: 'Inteliax',
      status: 'offline',
      avatar: '',
    }

    public client = {
      name: 'Guest User',
      status: 'online',
      avatar: '',
    }

    private static readonly SEPARADOR_BOTAO = ';;'

    private static readonly HOST_CHAT = /^([a-z0-9-]+-)?chat\.(tlv7|inteliax)\./

    private ehLinkNavegavel(url: string): boolean {
      let destino: URL
      try {
        destino = new URL(url)
      } catch {
        return false
      }

      if (destino.protocol !== 'http:' && destino.protocol !== 'https:') {
        return false
      }

      return !ChatService.HOST_CHAT.test(destino.host)
    }

    public processarBotoes(botoes: any[]): BotaoChat[] {
      if (!Array.isArray(botoes)) {
        return [];
      }

      return botoes.map(botao => {
        if (botao != null && typeof botao === 'object') {
          return botao as BotaoChat;
        }

        if (typeof botao !== 'string') {
          return null;
        }

        const partes = botao.split(ChatService.SEPARADOR_BOTAO);
        const texto = partes[0].trim();

        if (partes.length < 2) {
          return { texto, url: '', tipo: 'resposta'};
        }

        const url = partes.slice(1).join(ChatService.SEPARADOR_BOTAO).trim();

        return this.ehLinkNavegavel(url)
          ? { texto, url, tipo: 'link' }
          : { texto, url, tipo: 'bloqueado' };
        
      }).filter((botao): botao is BotaoChat => botao != null);
    }

    public addMessage(from, text, direcao:number,guid = "", id = - 1, anexo = false, anexoConteudo?, botoes?, guidFila?) {

      let type = ""

      if(direcao == 1 || direcao == 2){
        type = 'received'}
      else{
        type = 'sent'
      }

        this.messages.unshift({
          guid,
          id,
          from,
          text,
          type,
          date: new Date().getTime(),
          anexo,
          anexoConteudo,
          botoes: this.processarBotoes(botoes),
          guidFila
        })
        this.menssagemPersistidas   = JSON.stringify(this.messages);
        var obj = { exp: Date.now() }
        this.expTime = JSON.stringify(obj);
    }

    public addEvento(text: string) {
      const ultima = this.messages[0];
      if (ultima != null && ultima.type === 'evento' && ultima.text === text) {
        return;
      }

      this.messages.unshift({
        guid: "",
        id: -1,
        from: null,
        text,
        type: 'evento',
        date: new Date().getTime(),
        anexo: false
      })
      this.menssagemPersistidas = JSON.stringify(this.messages);
    }

    public changeAvatarFromName(name){
      var strGenero = getGender(name, 'it').charAt(0)
      var numImagem = Math.floor((Math.random() * 50) + 1);
      if(strGenero == 'u'){strGenero = "m"}
      let avatar =  this.appApiUrl + `/assets/images/avatars/${strGenero}-${numImagem}.jpg`
      return avatar
    }

    public resetOperator(){
      this.operator.name = ""
      this.operator.avatar = this.logoPadrao
      this.sistema.avatar = this.logoPadrao
    }
}
